import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaCaracteristicasTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID, IDEmissao, DataReferencia, DataDocumento, CETIP, VersaoDocumento, ISIN, 
            NumeroSerie, NumeroEmissao, TipoAtivo, TipoOferta, SiteFiduciario, 
            FrequenciaJuros, FrequenciaAmortizacao, ResgateAntecipado, DataEmissao, 
            DataPrimeiraIntegralizacao, DataVencimento, DataCarenciaResgate, 
            DataResgateAntecipado, DataVencimentoAntecipado, Indexador, Remuneracao, 
            PUEmissao, SpreadEmissao, PrazoMedioEmissao, PrazoEmissao, QtdEmitida, 
            ValorSerie, ValorTotalEmissao, CotaSubordinacao, CascataPagamento, LiquidezDiaria, 
            Conversibilidade, Incentivada, Green, Lei12431, Lei14801, PrePagamento, GarantiasReais, 
            GarantiasFidejussorias, MitigadorRiscoCredito, Covenants, CPFCNPJ_AgenteFiduciario, 
            CPFCNPJ_IFContaRecebedora, CPFCNPJ_Registrador, CPFCNPJ_Depositario, CPFCNPJ_Escriturador,CPFCNPJ_Custodiante, 
            CPFCNPJ_Auditoria, CPFCNPJ_AgenciaRating, CPFCNPJ_Emissor, CPFCNPJ_Cedente, 
            CPFCNPJ_Devedor, ResumoDevedor, Setor, Subsetor, DestinacaoRecursos, Coobrigacao, 
            RepactuacaoCredito, Inativo
        } = newRow

        const body = {
            "IDEmissao": IDEmissao,
            "DataReferencia": DataReferencia,
            "DataDocumento": DataDocumento,
            "CETIP": CETIP,
            "VersaoDocumento": VersaoDocumento,
            "ISIN": ISIN, 
            "NumeroSerie": NumeroSerie, 
            "NumeroEmissao": NumeroEmissao, 
            "TipoAtivo": TipoAtivo, 
            "TipoOferta": TipoOferta, 
            "SiteFiduciario": SiteFiduciario, 
            "FrequenciaJuros": FrequenciaJuros, 
            "FrequenciaAmortizacao": FrequenciaAmortizacao, 
            "ResgateAntecipado": ResgateAntecipado, 
            "DataEmissao": DataEmissao, 
            "DataPrimeiraIntegralizacao": DataPrimeiraIntegralizacao, 
            "DataVencimento": DataVencimento, 
            "DataCarenciaResgate": DataCarenciaResgate, 
            "DataResgateAntecipado": DataResgateAntecipado, 
            "DataVencimentoAntecipado": DataVencimentoAntecipado, 
            "Indexador": Indexador, 
            "Remuneracao": Remuneracao, 
            "PUEmissao": PUEmissao, 
            "SpreadEmissao": SpreadEmissao, 
            "PrazoMedioEmissao": PrazoMedioEmissao, 
            "PrazoEmissao": PrazoEmissao, 
            "QtdEmitida": QtdEmitida, 
            "ValorSerie": ValorSerie, 
            "ValorTotalEmissao": ValorTotalEmissao, 
            "CotaSubordinacao": CotaSubordinacao, 
            "CascataPagamento": CascataPagamento, 
            "LiquidezDiaria": LiquidezDiaria, 
            "Conversibilidade": Conversibilidade, 
            "Incentivada": Incentivada, 
            "Green": Green, 
            "Lei12431": Lei12431, 
            "Lei14801": Lei14801, 
            "PrePagamento": PrePagamento, 
            "GarantiasReais": GarantiasReais, 
            "GarantiasFidejussorias": GarantiasFidejussorias, 
            "MitigadorRiscoCredito": MitigadorRiscoCredito, 
            "Covenants": Covenants, 
            "CPFCNPJ_AgenteFiduciario": CPFCNPJ_AgenteFiduciario, 
            "CPFCNPJ_IFContaRecebedora": CPFCNPJ_IFContaRecebedora, 
            "CPFCNPJ_Registrador": CPFCNPJ_Registrador, 
            "CPFCNPJ_Depositario": CPFCNPJ_Depositario, 
            "CPFCNPJ_Escriturador": CPFCNPJ_Escriturador,
            "CPFCNPJ_Custodiante": CPFCNPJ_Custodiante, 
            "CPFCNPJ_Auditoria": CPFCNPJ_Auditoria, 
            "CPFCNPJ_AgenciaRating": CPFCNPJ_AgenciaRating, 
            "CPFCNPJ_Emissor": CPFCNPJ_Emissor, 
            "CPFCNPJ_Cedente": CPFCNPJ_Cedente, 
            "CPFCNPJ_Devedor": CPFCNPJ_Devedor, 
            "ResumoDevedor": ResumoDevedor, 
            "Setor": Setor, 
            "Subsetor": Subsetor, 
            "DestinacaoRecursos": DestinacaoRecursos, 
            "Coobrigacao": Coobrigacao, 
            "RepactuacaoCredito": RepactuacaoCredito,
            "Inativo": Inativo,
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }



    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataDocumento',
            headerName: 'DataDocumento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'VersaoDocumento',
            headerName: 'VersaoDocumento',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'NumeroSerie',
            headerName: 'NumeroSerie',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'NumeroEmissao',
            headerName: 'NumeroEmissao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoAtivo',
            headerName: 'TipoAtivo',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoOferta',
            headerName: 'TipoOferta',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SiteFiduciario',
            headerName: 'SiteFiduciario',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FrequenciaJuros',
            headerName: 'FrequenciaJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FrequenciaAmortizacao',
            headerName: 'FrequenciaAmortizacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ResgateAntecipado',
            headerName: 'ResgateAntecipado',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataEmissao',
            headerName: 'DataEmissao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataPrimeiraIntegralizacao',
            headerName: 'DataPrimeiraIntegralizacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataVencimento',
            headerName: 'DataVencimento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataCarenciaResgate',
            headerName: 'DataCarenciaResgate',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataResgateAntecipado',
            headerName: 'DataResgateAntecipado',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataVencimentoAntecipado',
            headerName: 'DataVencimentoAntecipado',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'Indexador',
            headerName: 'Indexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Remuneracao',
            headerName: 'Remuneracao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PUEmissao',
            headerName: 'PUEmissao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SpreadEmissao',
            headerName: 'SpreadEmissao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PrazoMedioEmissao',
            headerName: 'PrazoMedioEmissao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PrazoEmissao',
            headerName: 'PrazoEmissao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtdEmitida',
            headerName: 'QtdEmitida',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ValorSerie',
            headerName: 'ValorSerie',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ValorTotalEmissao',
            headerName: 'ValorTotalEmissao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CotaSubordinacao',
            headerName: 'CotaSubordinacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CascataPagamento',
            headerName: 'CascataPagamento',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'LiquidezDiaria',
            headerName: 'LiquidezDiaria',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Conversibilidade',
            headerName: 'Conversibilidade',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Incentivada',
            headerName: 'Incentivada',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Green',
            headerName: 'Green',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Lei12431',
            headerName: 'Lei12431',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Lei14801',
            headerName: 'Lei14801',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PrePagamento',
            headerName: 'PrePagamento',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'GarantiasReais',
            headerName: 'GarantiasReais',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'GarantiasFidejussorias',
            headerName: 'GarantiasFidejussorias',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'MitigadorRiscoCredito',
            headerName: 'MitigadorRiscoCredito',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Covenants',
            headerName: 'Covenants',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_AgenteFiduciario',
            headerName: 'CPFCNPJ_AgenteFiduciario',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_IFContaRecebedora',
            headerName: 'CPFCNPJ_IFContaRecebedora',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Registrador',
            headerName: 'CPFCNPJ_Registrador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Depositario',
            headerName: 'CPFCNPJ_Depositario',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Escriturador',
            headerName: 'CPFCNPJ_Escriturador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Custodiante',
            headerName: 'CPFCNPJ_Custodiante',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Auditoria',
            headerName: 'CPFCNPJ_Auditoria',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_AgenciaRating',
            headerName: 'CPFCNPJ_AgenciaRating',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Emissor',
            headerName: 'CPFCNPJ_Emissor',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Cedente',
            headerName: 'CPFCNPJ_Cedente',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Devedor',
            headerName: 'CPFCNPJ_Devedor',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ResumoDevedor',
            headerName: 'ResumoDevedor',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Setor',
            headerName: 'Setor',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Subsetor',
            headerName: 'Subsetor',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DestinacaoRecursos',
            headerName: 'DestinacaoRecursos',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Coobrigacao',
            headerName: 'Coobrigacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'RepactuacaoCredito',
            headerName: 'RepactuacaoCredito',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Inativo',
            headerName: 'Inativo',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true}
                useDeleteButton={false} />
        </div>
    )
}

ParameterEmissaoRendaFixaCaracteristicasTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaCaracteristicasTable